import * as React from 'react';
import { HeaderVideoContext } from './useHeaderVideo';

/**
 * Provides `useHeaderVideo()` for any descendant — lets a chat message bubble
 * "promote" its lipsync video into the chat header for fullscreen-style playback.
 */
export const HeaderVideoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeVideoUrl, setActiveVideoUrl] = React.useState<string | null>(null);

  const playVideoInHeader = React.useCallback((url: string) => {
    setActiveVideoUrl(url);
  }, []);

  const clearActiveVideo = React.useCallback(() => {
    setActiveVideoUrl(null);
  }, []);

  const value = React.useMemo(
    () => ({ activeVideoUrl, playVideoInHeader, clearActiveVideo }),
    [activeVideoUrl, playVideoInHeader, clearActiveVideo]
  );

  return <HeaderVideoContext.Provider value={value}>{children}</HeaderVideoContext.Provider>;
};
